import * as yup from 'yup';

export const spaceValidation = yup
	.string()
	.trim()
	.matches(/^\S*$/, "The filename shouldn't contain spaces");
